import {Component, EventEmitter, forwardRef, Injector, Input, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {MiscelaneaService} from '../../services/miscelanea.service';

const SELECT_VNA_VARS_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaVarsComponent)
};
@Component({
    selector: 'app-select-vna-vars',
    template: `        
        <ngx-select [items]="vars" [(ngModel)]="selectedValue" [optionValueField]="valueField" [optionTextField]="textField" [allowClear]="true" (select)="onSelected($event)">
                    <ng-template ngx-select-option ngx-select-option-selected let-option let-text="text">
                      {{option.data.label}}
                    </ng-template>
                </ngx-select>
      `,
    styleUrls: ['./select-vna-vars.component.scss'],
    providers:[SELECT_VNA_VARS_VALUE_ACCESSOR]
})
export class SelectVnaVarsComponent implements OnInit, ControlValueAccessor {

    _selectedValue:any;
    vars: Array<Object> = [];

    @Input() valueField: string = 'id';
    @Input() textField: string = 'label';

    @Input() portal: string;
    @Input() campName: string;

    @Output() change: EventEmitter<string> = new EventEmitter<string>();

    constructor(private miscService: MiscelaneaService) {}

    ngOnInit() {
        this.miscService.findAllowedVars(this.portal, this.campName)
            .subscribe((result) =>{
                this.vars = result;
            })
        ;
    }

    get selectedValue(): any {
        return this._selectedValue;
    };

    set selectedValue(v: any) {
        this._selectedValue = v;
        this.propagateChange(this._selectedValue);
    }

    onSelected(e: any): void {
        this.change.emit(e);
    }

    propagateChange = (_: any) => {};

    onTouched = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._selectedValue = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/shared/components/select-vna-vars/select-vna-vars.component.ts